import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Casino = class Casino extends Vue {
    constructor() {
        super(...arguments);
        this.slots = [[""], [""], [""]];
        this.cursor0 = 0;
        this.cursor1 = 0;
        this.cursor2 = 0;
        this.loops = [true, true, true];
        this.startTimes = [0, 0, 0];
        this.progressTimes = [0, 0, 0];
        this.problemTimes = [400, 300, 200];
        this.slots1 = [
            ["お", "？", "つ", "さ", "あ", "〇", "１", "□", "た", "さ", "ひ", "ょ"],
            ["ん", "？", "く", "い", "っ", "〇", "は", "□", "３", "い", "か", "は"],
            ["な", "？", "れ", "ご", "と", "〇", "５", "□", "ね", "し", "り", "き"]
        ];
        this.slots2 = [
            ["お", "？", "つ", "さ", "し", "〇", "こ", "＠", "２", "に", "き", "め"],
            ["と", "？", "く", "い", "か", "〇", "４", "＠", "え", "も", "の", "は"],
            ["こ", "？", "れ", "ご", "く", "〇", "か", "＠", "６", "じ", "み", "つ"]
        ];
    }
    getLiteral(column, cursor) {
        const length = this.slots[column].length;
        return this.slots[column][cursor % length];
    }
    stop(slot) {
        this.loops[slot] = !this.loops[slot];
        if (this.loops[slot]) {
            this.request(slot);
        }
    }
    mounted() {
        if (this.player == 1) {
            this.slots = this.slots1;
        }
        else if (this.player == 2) {
            this.slots = this.slots2;
        }
        this.requestAll();
    }
    request(slot) {
        if (slot == 0) {
            window.requestAnimationFrame(this.animeSlot0);
        }
        else if (slot == 1) {
            window.requestAnimationFrame(this.animeSlot1);
        }
        else if (slot == 2) {
            window.requestAnimationFrame(this.animeSlot2);
        }
    }
    requestAll() {
        window.requestAnimationFrame(this.animeSlot0);
        window.requestAnimationFrame(this.animeSlot1);
        window.requestAnimationFrame(this.animeSlot2);
    }
    animeSlot0(timestamp) {
        const slot = 0;
        if (!this.startTimes[slot])
            this.startTimes[slot] = timestamp;
        this.progressTimes[slot] = timestamp - this.startTimes[slot];
        if (this.progressTimes[slot] < this.problemTimes[slot]) {
            if (!this.loops[slot]) {
                return;
            }
            window.requestAnimationFrame(this.animeSlot0);
            return;
        }
        this.cursor0 = (this.cursor0 + 1) % this.slots[slot].length;
        this.startTimes[slot] = 0;
        if (this.loops[slot]) {
            window.requestAnimationFrame(this.animeSlot0);
        }
    }
    animeSlot1(timestamp) {
        const slot = 1;
        const slotAnime = this.animeSlot1;
        if (!this.startTimes[slot])
            this.startTimes[slot] = timestamp;
        this.progressTimes[slot] = timestamp - this.startTimes[slot];
        if (this.progressTimes[slot] < this.problemTimes[slot]) {
            if (!this.loops[slot]) {
                return;
            }
            window.requestAnimationFrame(slotAnime);
            return;
        }
        this.cursor1 = (this.cursor1 + 1) % this.slots[slot].length;
        this.startTimes[slot] = 0;
        if (this.loops[slot]) {
            window.requestAnimationFrame(slotAnime);
        }
    }
    animeSlot2(timestamp) {
        const slot = 2;
        const slotAnime = this.animeSlot2;
        if (!this.startTimes[slot])
            this.startTimes[slot] = timestamp;
        this.progressTimes[slot] = timestamp - this.startTimes[slot];
        if (this.progressTimes[slot] < this.problemTimes[slot]) {
            if (!this.loops[slot]) {
                return;
            }
            window.requestAnimationFrame(slotAnime);
            return;
        }
        this.cursor2 = (this.cursor2 + 1) % this.slots[slot].length;
        this.startTimes[slot] = 0;
        if (this.loops[slot]) {
            window.requestAnimationFrame(slotAnime);
        }
    }
};
__decorate([
    Prop()
], Casino.prototype, "cleared", void 0);
__decorate([
    Prop()
], Casino.prototype, "player", void 0);
Casino = __decorate([
    Component
], Casino);
export default Casino;
